import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'activePeriods',
  baseType: 'ACTIVE_PERIODS',
  apiEndpoint: 'active_periods'
};

const metadataApiSelectors = createMetadataAPISelectors(options);

const activePeriodsByUserAndGroupId = state => state.activePeriods.byUserAndGroupId;

export default {
  ...metadataApiSelectors,
  activePeriodsByUserAndGroupId
};
